import { getMessage } from '../../components';

export default (messages) => {
    return {
        addressLine1: {
            identifier: 'addressLine1',
            required: true,
            validations: {
                maxLength: 128
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.address1'), '128'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.address1')
            }
        },
        addressLine2: {
            identifier: 'addressLine2',
            required: false,
            validations: {
                maxLength: 128
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.address2'), '128'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.address2')
            }
        },
        addressCity: {
            identifier: 'addressCity',
            required: true,
            validations: {
                maxLength: 100
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.address'), '100'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.city')
            }
        },
        addressRegion: {
            identifier: 'addressState',
            required: false,
            validations: {
                maxLength: 32
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.region'), '32'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.region')
            }
        },
        addressState: {
            identifier: 'addressState',
            required: true,
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.region')
            }
        },
        addressPostCode: {
            identifier: 'addressPostCode',
            required: false,
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.zip'), '32'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.zip')
            }
        },
        addressZipCode: {
            identifier: 'addressPostCode',
            required: true,
            validations: {
                maxLength: 10,
                isValidZip: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.zip'), '10']),
                isValidZip: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.zip')])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.zip')
            }
        },
        mailingAddressLine1: {
            identifier: 'mailingAddressLine1',
            required: true,
            validations: {
                maxLength: 128
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.address1'), '128'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.address1')
            }
        },
        mailingAddressLine2: {
            identifier: 'mailingAddressLine2',
            required: false,
            validations: {
                maxLength: 128
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.address2'), '128'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.address2')
            }
        },
        mailingAddressCity: {
            identifier: 'mailingAddressCity',
            required: true,
            validations: {
                maxLength: 100
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.address'), '100'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.city')
            }
        },
        mailingAddressRegion: {
            identifier: 'mailingAddressState',
            required: false,
            validations: {
                maxLength: 32
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.region'), '32'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.region')
            }
        },
        mailingAddressState: {
            identifier: 'mailingAddressState',
            required: true,
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.region')
            }
        },
        mailingAddressPostCode: {
            identifier: 'mailingAddressPostCode',
            required: false,
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.zip'), '32'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.zip')
            }
        },
        mailingAddressZipCode: {
            identifier: 'mailingAddressPostCode',
            required: true,
            validations: {
                maxLength: 10,
                isValidZip: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.zip'), '10']),
                isValidZip: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.zip')])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.zip')
            }
        },
        guardianFirstName: {
            identifier: 'guardianFirstName',
            required: true,
            validations: {
                maxLength: 50
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.guardian.firstName'), '50'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.guardian.firstName')
            }
        },
        guardianLastName: {
            identifier: 'guardianLastName',
            required: true,
            validations: {
                maxLength: 50
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.guardian.lastName'), '50'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.guardian.lastName')
            }
        },
        guardianEmail: {
            identifier: 'guardianEmail',
            required: true,
            validations: {
                isEmail: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isEmail: getMessage(messages, 'errors.epic.validation.email')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.guardian.email')
            }
        },
        guardianPhoneNumber: {
            identifier: 'guardianPhoneNumber',
            required: true,
            validations: {
                maxLength: 17,
                isValidPhoneNumber: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isValidPhoneNumber: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.phoneNumber')]),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.guardian.phone'), '17'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.guardian.phone')
            }
        }
    };
};
